export default defineNuxtRouteMiddleware(async (to) => {
  const tech = useTech()

  to.meta.layout = tech.id || useRoute().meta.layout || 'default'
  to.meta.theme = tech.currentTheme || 'theme-lapiz'
})
